import rewardsRoutes from '../routes/rewards';
import orderingRoutes from '../routes/ordering';
import siteRoutes from '../routes/site';
import { resolveSitePath } from '../containers/Site/routing/siteLocation';

/**
 * Site-surface paths go through the page graph resolver, because these helpers
 * are the one set of consumers that never reaches the patched Site history —
 * most importantly the payment-gateway callback URL, which a stale ordering
 * prefix would point at a 404 after the customer has paid.
 *
 * Other surfaces are mounted route groups, not graph-published, so they are
 * returned as coded.
 */
const forSite = (path) => resolveSitePath(path);

export const getSurfaceBasePath = (surface) => {
  switch (surface) {
    case 'ordering':
      return '';
    case 'site':
      return '';
    case 'app':
    default:
      return `/${rewardsRoutes.rewards}`;
  }
};

export const getOrderingBasePath = (surface) => {
  if (surface === 'site') return forSite(`/${siteRoutes.containers.order}`);
  if (surface === 'ordering') return `/${orderingRoutes.ordering}`;
  return `/${rewardsRoutes.rewards}/${rewardsRoutes.containers.ordering}`;
};

export const getLocationsBasePath = (surface) => {
  const base = getSurfaceBasePath(surface);
  const locations = rewardsRoutes.containers.locations;
  if (surface === 'site') return forSite(`/${locations}`);
  return base ? `${base}/${locations}` : `/${locations}`;
};

export const getLocationDetailPath = (surface, outletId, search = '') => {
  const base = getLocationsBasePath(surface);
  return `${base}/${outletId}${search || ''}`;
};

/**
 * Wallet base path from Redux/ThemeContext surface.
 * App → /app/wallet; site + ordering → /wallet.
 */
export const getWalletBasePath = (surface) => {
  if (surface === 'app') {
    return `${getSurfaceBasePath('app')}/${rewardsRoutes.containers.wallet}`;
  }
  if (surface === 'site') return forSite(`/${rewardsRoutes.containers.wallet}`);
  return `/${rewardsRoutes.containers.wallet}`;
};

/** Site guests can browse and add to cart; login is required at checkout only. */
export const isOrderingMenuReadOnly = ({ surface, isGuestMode, configReadOnly = false }) => {
  if (surface === 'site' && isGuestMode) {
    return false;
  }
  return !!configReadOnly || !!isGuestMode;
};
